import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { toast } from "react-toastify";
import {
    createAPIEndpointServiceInvoice,
    EndpointServiceInvoice,
} from "../../Services/ServiceInvoice/ServiceInvoiceService";
import { InputNumber } from "primereact/inputnumber";

const InformationUrban = ({
    showDialog,
    setShowDialog,
    showGST,
    allRecordsData,
    setAllRecordsData,
}) => {
    const [amountBeforeTax, setAmountBeforeTax] = useState(0);
    const [igstAmount, setIgstAmount] = useState(0);
    const [cgstAmount, setcgstAmount] = useState(0);
    const [utgstAmount, setutgstAmount] = useState(0);
    const [totalAmt, setTotalAmt] = useState(0);
    const [selectedServiceDetails, setSelectedServiceDetails] = useState(null);
    const rowIndex = allRecordsData.length + 1;
    const [formData, setFormData] = useState({
        row: rowIndex,
        Service_Details: selectedServiceDetails,
        Amount_Excluding_GST: amountBeforeTax,
        IGST_Amount: igstAmount,
        CGST_Amount: cgstAmount,
        SGST_UTGST_Amount: utgstAmount,
        IGST: 18,
        CGST: 9,
        SGST_UTGST: 9,
        Total_Amount: totalAmt,
    });
    const [serviceDetailsOptions, setServiceDetailsOptions] = useState([]);
    const [RSEOptions, setRSEOptions] = useState([]);

    const handleChange = async () => {
        if (!selectedServiceDetails) {
            toast.error("Please select service detail", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (amountBeforeTax == 0) {
            toast.error("Amount Before Tax must be greater than zero.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }

        const newRecords = [];

        const normalRecord = {
            ...formData,
            Amount_Excluding_GST: amountBeforeTax,
            Total_Amount: totalAmt,
            IGST_Amount: igstAmount,
            CGST_Amount: cgstAmount,
            SGST_UTGST_Amount: utgstAmount,
            IGST: igstAmount > 0 ? 18 : 0,
            CGST: cgstAmount > 0 ? 9 : 0,
            SGST_UTGST: utgstAmount > 0 ? 9 : 0,
        };
        newRecords.push(normalRecord);

        setFormData(normalRecord);
        setAllRecordsData([...allRecordsData, ...newRecords]);
        setShowDialog(false);
    };

    const handleDropdownChange = (e) => {
        setSelectedServiceDetails(e.value);
        const foundObject = serviceDetailsOptions.find(
            (item) => item.value === e.value,
        );
        setFormData((prevData) => ({
            ...prevData,
            Service_Details: foundObject?.label,
        }));
    };

    const calculateTaxes = () => {
        if (amountBeforeTax == 0) {
            setcgstAmount(0);
            setutgstAmount(0);
            setIgstAmount(0);
        }
        if (amountBeforeTax > 0) {
            if (showGST) {
                setIgstAmount(parseFloat(((18 / 100) * amountBeforeTax).toFixed(2)));
                setcgstAmount(0);
                setutgstAmount(0);
            } else {
                setIgstAmount(0);
                setcgstAmount(parseFloat(((9 / 100) * amountBeforeTax).toFixed(2)));
                setutgstAmount(parseFloat(((9 / 100) * amountBeforeTax).toFixed(2)));
            }
        }
    };
    const calculateTotalAmt = () => {
        if (amountBeforeTax == 0) setTotalAmt(0);
        if (amountBeforeTax > 0) {
            showGST
                ? setTotalAmt((Number(amountBeforeTax) + Number(igstAmount)).toFixed(2))
                : setTotalAmt(
                    (
                        Number(amountBeforeTax) +
              (Number(cgstAmount) + Number(utgstAmount))
                    ).toFixed(2),
                );
        }
    };

    useEffect(() => {
        const getServiceDetailsRSE = async () => {
            try {
                const response = await createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.PopulateRSEServiceDetails}?ServiceType=URBAN`,
                );
                const filteredData = response.data.Data.map((val) => ({
                    value: val?.ID,
                    label: val?.SERVICE_DETAILS,
                }));
                setServiceDetailsOptions(filteredData);
                setRSEOptions(filteredData);
            } catch (e) {
                console.log("Error", e);
            }
        };
        getServiceDetailsRSE();
    }, []);

    useEffect(() => {
        let filteredOptions = RSEOptions;

        if (allRecordsData.length === 0) {
            setServiceDetailsOptions(RSEOptions);
        } else {
            const existingDetails = allRecordsData.map((item) =>
                item.Service_Details?.trim().toLowerCase(),
            );
            filteredOptions = serviceDetailsOptions.filter(
                (option) =>
                    !existingDetails.includes(option.label.trim().toLowerCase()),
            );

            setServiceDetailsOptions(filteredOptions);
        }
    }, [RSEOptions]);

    useEffect(() => {
        calculateTaxes();
    }, [amountBeforeTax]);

    useEffect(() => {
        calculateTotalAmt();
    }, [igstAmount, utgstAmount, cgstAmount]);

    return (
        <>
            <Dialog
                header="Information"
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{ width: "60vw" }}
                closable={false}
                draggable={false}
                resizable={false}
                footer={() => {
                    return (
                        <div>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={handleChange}
                                >
                  Ok
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-cancel-red"
                                    onClick={() => setShowDialog(false)}
                                >
                  Close
                                </button>
                            </div>
                        </div>
                    );
                }}
            >
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Row</label>
                            <InputText
                                className="form-control"
                                value={allRecordsData.length + 1}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Service Details</label>
                            <Dropdown
                                value={selectedServiceDetails}
                                options={serviceDetailsOptions}
                                onChange={handleDropdownChange}
                                optionLabel="label"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Amount Before Tax</label>
                            <InputNumber
                                className="d-block"
                                value={amountBeforeTax}
                                onValueChange={(e) => setAmountBeforeTax(e.value)}
                                prefix="₹ "
                                min={0}
                                max={10000000}
                            />
                        </div>
                    </div>
                    {showGST && (
                        <>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">IGST %</label>
                                    <InputText className="form-control" value="18%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">IGST Amount</label>
                                    <InputText
                                        className="form-control"
                                        value={igstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {!showGST && (
                        <>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">CGST %</label>
                                    <InputText className="form-control" value="9%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">CGST Amount</label>
                                    <InputText
                                        className="form-control"
                                        value={cgstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">SGST/UTGST %</label>
                                    <InputText className="form-control" value="9%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">
                    SGST/UTGST Amount
                                    </label>
                                    <InputText
                                        className="form-control"
                                        value={utgstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Total Amount</label>
                            <InputText className="form-control" value={totalAmt} disabled />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default InformationUrban;
